module.exports = __webpack_public_path__ + "phabricator-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/phabricator-logo.png
// module id = 1263
// module chunks = 74